$(".range-group input").on("input", function () {
  var val = ($(this).val() - $(this).attr("min")) / ($(this).attr("max") - $(this).attr("min"));
  var percent = val * 100;
  var unit = $(this).data("unit");
  var output = $(this).val();

  if (unit === "cm") {
    $("#input-height").val(output);
    output = output + "cm";
  }

  if (unit === "ft") {
    var feet = Math.floor(output / 12);
    var inch = Math.ceil((output / 12 - feet) * 10);
    var cm = Math.ceil(output * 2.54);
    $("#input-height").val(cm);
    output = feet + "'" + inch + '"';
  }

  if (unit === "kg") {
    $("#input-weight").val(output);
    output = output + "kg";
  }

  if (unit === "lbs") {
    var kg = Math.ceil(output / 2.205);
    $("#input-weight").val(kg);
    output = output + "lbs";
  }

  $(this).siblings(".output").text(output);
  $(this).css("background-image", "-webkit-gradient(linear, left top, right top, " + "color-stop(" + percent + "%, #034ea2), " + "color-stop(" + percent + "%, #fff)" + ")");
  $(this).css("background-image", "-moz-linear-gradient(left center, #034ea2 0%, #034ea2 " + percent + "%, #fff " + percent + "%, #fff 100%)");
});
$(".qtooltip").hover(function () {
  //On Hover - Works on ios
  $(this).child("i").hide();
}, function () {
  //Hover Off - Hover off doesn't seem to work on iOS
  $(this).child("i").show();
}); // @codekit-prepend "input.js";

$(".quiz-intro").addClass("active");
quizElementVisibility(1); // const BMR = calcBMR(40, 30);
// let calories = calcCalories(BMR, "maintain", "moderate");
// const macro = calcMacro(40, calories, 30);
// printResult(macro, calories, "gain");

function quizMoveStep(currentStep, move) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var stepActive = move === "next" ? parseInt(currentStep) + 1 : parseInt(currentStep) - 1;
  setTimeout(function () {
    $(".quiz-step[data-step=" + currentStep + "]").removeClass("active");
    $(".quiz-step[data-step=" + stepActive + "]").addClass("active");
    quizElementVisibility(stepActive);
    quizPrintStep();
    document.activeElement.blur();
    $(window).scrollTop(0);
  }, delay);
}

function quizElementVisibility(stepActive) {
  var currentStep = $(".quiz-step[data-step=" + stepActive + "].active");
  var hideBack = currentStep.data("hide-back");
  var hideStep = currentStep.data("hide-step");
  var hideIcon = currentStep.data("hide-icon");
  var hideLogo = currentStep.data("hide-logo");
  var showNext = currentStep.data("show-next");

  if (stepActive === 1) {
    $("body").addClass("quiz-start");
  }

  hideBack ? $(".quiz-prev").hide() : $(".quiz-prev").show();
  showNext ? $(".quiz-next").show() : $(".quiz-next").hide();
  hideStep ? $(".quiz-step-status").hide() : $(".quiz-step-status").show();
  hideIcon ? $(".quiz-sm-icon").hide() : $(".quiz-sm-icon").show();

  if (hideLogo) {
    $(".logo-generic").hide();
    $(".logo-white").show();
  } else {
    $(".logo-generic").show();
    $(".logo-white").hide();
  }
}

function quizPrintStep() {
  var currentStep = parseInt($(".quiz-step.active").data("step")) - 1;
  $(".quiz-current-step").text(currentStep);
}

function tick(input, status) {
  status ? $(input).siblings(".tick").addClass("correct") : $(input).siblings(".tick").removeClass("correct");
}

$(".quiz-prev").click(function (e) {
  e.preventDefault();
  var currentStep = $(".quiz-step.active").data("step");
  quizMoveStep(currentStep, "prev");
});
$(".quiz-next").click(function (e) {
  e.preventDefault();
  var currentStep = $(".quiz-step.active").data("step");
  quizMoveStep(currentStep, "next");
});
$(".quiz-intro .btn").click(function (e) {
  e.preventDefault();
  $("body").removeClass("quiz-start");
  quizMoveStep(1, "next");
}); // Age

$("#input-age").on("input", function () {
  $(".quiz-age").data("show-next", true);
  var input = $(this).val().toString();

  if (input.length === 2) {
    tick(this, true);
    quizMoveStep(2, "next", 500);
  } else {
    tick(this, false);
  }
}); //Height

$(".quiz-height .radio-group input").on("input", function () {
  $(".quiz-age").data("show-next", true);
  var unit = $(this).val();

  if (unit === "cm") {
    $(".quiz-height .range-group.metric").addClass("active").siblings().removeClass("active");
  } else {
    $(".quiz-height .range-group.imperial").addClass("active").siblings().removeClass("active");
  }
});
$(".quiz-height .range-group input").change(function () {
  $(".quiz-height").data("show-next", true);
  quizMoveStep(3, "next", 500);
}); //weight

$(".quiz-weight .radio-group input").on("input", function () {
  var unit = $(this).val();

  if (unit === "kg") {
    $(".quiz-weight .range-group.metric").addClass("active").siblings().removeClass("active");
  } else {
    $(".quiz-weight .range-group.imperial").addClass("active").siblings().removeClass("active");
  }
});
$(".quiz-weight .range-group input").change(function () {
  quizMoveStep(4, "next", 500);
  $(".quiz-weight").data("show-next", true);
}); //bodyfat

$("#input-bodyfat-temp").on("input", function () {
  var input = $(this).val().toString();
  $("#input-bodyfat").val(input);

  if (input.length === 2) {
    tick(this, true);
    $(".quiz-bodyfat .radio-group input").prop("checked", false);
    quizMoveStep(5, "next", 500);
  } else {
    tick(this, false);
  }
});
$(".quiz-bodyfat .radio-group input").on("change", function () {
  var input = $(this).val();
  $("#input-bodyfat-temp").val("");
  $("#input-bodyfat").val(input);
  quizMoveStep(5, "next", 500);
  $(".quiz-bodyfat").data("show-next", true);
}); //goal

$(".quiz-goal .radio-group input").on("input", function () {
  var input = $(this).val();
  $("#input-goal").val(input);
  quizMoveStep(6, "next", 500);
  $(".quiz-goal").data("show-next", true);
}); //bodyshape

$(".quiz-bodyshape .radio-group input").on("input", function () {
  var input = $(this).val();
  $("#input-bodyshape").val(input);
  quizMoveStep(8, "next", 500);
  $(".quiz-bodyshape").data("show-next", true);
}); //active

$(".quiz-active .radio-group input").on("input", function () {
  var input = $(this).val();
  $("#input-active").val(input);
  quizMoveStep(7, "next", 500);
  $(".quiz-active").data("show-next", true);
}); //email

$("#input-email").on("input", function () {
  var input = $(this).val();
  var ev = /^([_a-zA-Z0-9-]+)(\.[_a-zA-Z0-9-]+)*@([a-zA-Z0-9-]+\.)+([a-zA-Z]{2,3})$/;

  if (!ev.test(input)) {
    $(".quiz-email .btn").prop("disabled", true);
  } else {
    $(".quiz-email .btn").prop("disabled", false);
  }
});

function calcBMR(weight, bf) {
  var lbm = weight - weight * (bf / 100);
  return 370 + 21.6 * lbm;
}

function calcCalories(bmr, goal, active) {
  var activeRate = 0;
  if (active === "no") activeRate = 1.2;
  if (active === "light") activeRate = 1.375;
  if (active === "moderate") activeRate = 1.55;
  if (active === "extreme") activeRate = 1.725;
  var cals = bmr * activeRate;
  if (goal === "lose") cals = cals * 0.8;
  if (goal === "lose10") cals = cals * 0.9;
  if (goal === "gain") cals = cals * 1.2;
  return Math.round(cals);
}

function calcMacro(weight, calories, fatRatio) {
  var proteinGram = 1.815 * weight;
  var proteinRatio = proteinGram * 4 / calories * 100;
  var fatGram = calories * fatRatio / 100 / 9;
  var carbsRatio = 100 - (proteinRatio + fatRatio);
  var carbsGram = calories * carbsRatio / 100 / 4;
  return {
    gram: {
      carbs: Math.round(carbsGram),
      protein: Math.round(proteinGram),
      fat: Math.round(fatGram)
    },
    percentage: {
      carbs: carbsRatio.toFixed(1),
      protein: proteinRatio.toFixed(1),
      fat: fatRatio.toFixed(1)
    }
  };
}

function showResult() {
  $(".recommendations,.quiz-deal, .quiz-tnc").fadeIn("slow");
}

function printResult(macro, calories, inputgoal) {
  var _macro$percentage = macro.percentage,
      carbsPerc = _macro$percentage.carbs,
      proteinPerc = _macro$percentage.protein,
      fatPerc = _macro$percentage.fat;
  var _macro$gram = macro.gram,
      carbsGram = _macro$gram.carbs,
      proteinGram = _macro$gram.protein,
      fatGram = _macro$gram.fat;
  $("#quiz-calories").text(calories);
  $("#carboGram span").text(carbsGram);
  $("#carbPercentage span").text(carbsPerc);
  $("#proteinGram span").text(proteinGram);
  $("#proteinPercentage span").text(proteinPerc);
  $("#fatGram span").text(fatGram);
  $("#fatPercentage span").text(fatPerc);
  if (inputgoal === "lose") $(".result1").show();
  if (inputgoal === "lose10") $(".result2").show();
  if (inputgoal === "maintain") $(".result3").show();
  if (inputgoal === "gain") $(".result4").show();
  $(".qcount").each(function () {
    $(this).prop("Counter", 0).animate({
      Counter: $(this).text()
    }, {
      duration: 2000,
      easing: "swing",
      step: function step(now) {
        if (now % 1 === 0) {
          $(this).text(Math.ceil(now));
        } else {
          $(this).text(now.toFixed(1));
        }
      }
    });
  });
  setTimeout(showResult, 2300); // setTimeout(showResult, 0);
}

function getCtaUrl(goal) {
  if (goal === "lose") return $(".quiz-deals.result1 .btn").data('product-link');
  if (goal === "lose10") return $(".quiz-deals.result2 .btn").data('product-link');
  if (goal === "maintain") return $(".quiz-deals.result3 .btn").data('product-link');
  if (goal === "gain") return $(".quiz-deals.result4 .btn").data('product-link');
  return 'https://bodyboss.com';
}

var klaviyo_call_quiz = function(Email){
  const options = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      "store": "us-bodyboss",
      "email": Email
    })
  };
    
  fetch('https://skinnymint-php.herokuapp.com/', options)
  .then(response => response.json())
  .then(response => console.log(response))
  .catch(err => console.log(err));
}

document.addEventListener("StartKernelLoading", function () {
  console.log("quiz script loaded");
  urlForm = "https://bodybosstone.us20.list-manage.com/subscribe/post?u=0d61b8c53250bd298df34d010&amp;id=95789efdbb";
  $(".quiz-email .btn").click(function () {
    var _ref = [$("#input-age").val(), $("#input-height").val(), $("#input-weight").val(), $("#input-bodyfat").val(), $("#input-goal").val(), $("#input-bodyshape").val(), $("#input-active").val(), $("#input-email").val()],
        inputage = _ref[0],
        inputheight = _ref[1],
        inputweight = _ref[2],
        inputbodyfat = _ref[3],
        inputgoal = _ref[4],
        inputbodyshape = _ref[5],
        inputactive = _ref[6],
        inputemail = _ref[7];
    var quizinput = inputage + "yo, " + inputheight + "cm, " + inputweight + "kg, " + inputbodyfat + "%, " + inputbodyshape + ", " + inputactive;
    var checkoutUrl = getCtaUrl(inputgoal);
    var BMR = calcBMR(inputweight, inputbodyfat);
    var calories = calcCalories(BMR, inputgoal, inputactive);
    var macro = calcMacro(inputweight, calories, 30);
    printResult(macro, calories, inputgoal);
    var _macro$percentage2 = macro.percentage,
        carbsPerc = _macro$percentage2.carbs,
        proteinPerc = _macro$percentage2.protein,
        fatPerc = _macro$percentage2.fat;
    var _macro$gram2 = macro.gram,
        carbsGram = _macro$gram2.carbs,
        proteinGram = _macro$gram2.protein,
        fatGram = _macro$gram2.fat;
    var store = {
      "int-bodyboss.myshopify.com": "INT",
      "us-bodyboss.myshopify.com": "US",
      "au-bodyboss.myshopify.com": "AU",
      "uk-bodyboss.myshopify.com": "UK",
      "eu-bodyboss.myshopify.com": "EU",
      "ca-bodyboss.myshopify.com": "CA"
    };
    currentStore = store[Shopify.shop];
    $.ajax({
      url: urlForm,
      cache: false,
      data: {
        EMAIL: inputemail,
        QUIZINPUT: quizinput,
        CALORIES: calories,
        CARBS: carbsGram,
        PROTEIN: proteinGram,
        FAT: fatGram,
        CARBSP: carbsPerc,
        PROTEINP: proteinPerc,
        FATP: fatPerc,
        STORE: currentStore,
        GOAL: inputgoal,
        CTA: checkoutUrl
      },
      dataType: "jsonp",
      contentType: "application/json; charset=utf-8",
      beforeSend: function beforeSend() {
        $(".waitlist-form button").text("Submit...");
      },
      complete: function complete(resp) {}
    });
    klaviyo_call_quiz(inputemail);
    quizMoveStep(9, "next", 0);
  });
});